<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <h3>Thank You</h3>
    <table class="table">
      <thead>
      <tr>
        <th scope="col">Description</th>
        <th scope="col">Amount</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in cart.items" v-bind:key="item.id">
        <td>{{ item.description }}</td>
        <td>${{ item.amount }}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td>Total:</td>
        <td>${{ totalPrice }}</td>
      </tr>
      <tr v-bind:class="{'bg-success text-dark': payment.totalAmount === totalPrice}" v-if="payment">
        <td>Total Paid:</td>
        <td>${{ payment.totalAmount }}</td>
      </tr>
      </tfoot>
    </table>

    <dl class="row" v-if="chaseConfirmationNumber">
      <dt class="col-sm-3">Paymentus Confirmation Number:</dt>
      <dd class="col-sm-9">{{ chaseConfirmationNumber }}</dd>
    </dl>

    <p>
      Thank you for using the Cook County Department of Environment &amp; Sustainability on-line permit application
      system. After approval of your permit application by the department, it will be emailed to the address you
      provided with your application.
    </p>
    <dl class="row">
      <dt class="col-12">For Customer Service:</dt>
      <dt class="col-sm-3">Hours:</dt>
      <dd class="col-sm-9">8:30am - 4:30pm</dd>
      <dt class="col-sm-3">Phone:</dt>
      <dd class="col-sm-9">312-603-8200 (and follow appropriate prompt)</dd>
    </dl>
  </div>
</template>

<script>
import { confirmChasePayment, getCart } from '@/js/FormFunctions';

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'ThankYou',
  props: ['shoppingCart'],
  data() {
    return {
      fetchingData: false,
      chaseConfirmationNumber: null,
      chaseTransactionMode: null,
      returnSessionId: null,
      cart: {
        items: [],
      },
      payment: null,
    };
  },
  mounted() {
    // http://10.122.78.13/DesWebPortal/#/thankYou/shoppingCartId?returnSessionId=id&confirmationId=
    this.shoppingCart = this.$route.params.shoppingCart;
    if (Object.hasOwnProperty.call(this.$route.query, 'confirmationId')) {
      this.chaseConfirmationNumber = this.$route.query.confirmationId;
    }
    if (Object.hasOwnProperty.call(this.$route.query, 'returnSessionId')) {
      this.returnSessionId = this.$route.query.returnSessionId;
    }
    const vm = this;
    this.fetchingData = true;
    getCart(this.shoppingCart)
      .then((response) => {
        vm.fetchingData = false;
        vm.cart = response;
      })
      .catch(() => {
        vm.fetchingData = false;
      });
  },
  computed: {
    totalPrice() {
      if (this.cart.items.length === 0) {
        return 0;
      }
      return this.cart.items
        .map(i => i.amount)
        .reduce(sumReducer);
    },
  },
};
</script>
